import { render, staticRenderFns } from "./BravoApp.vue?vue&type=template&id=699f9e88&scoped=true&"
import script from "./BravoApp.vue?vue&type=script&lang=js&"
export * from "./BravoApp.vue?vue&type=script&lang=js&"
import style0 from "./BravoApp.vue?vue&type=style&index=0&id=699f9e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699f9e88",
  null
  
)

export default component.exports